module.exports = __webpack_public_path__ + "img/partner_3_2x.069f059f.png";